/**
 * Keys of feature flags, as returned with the user's organization
 */
export const featureFlags = {
    INBOX_2_0: 'INBOX_2_0',
};
